import React from "react";
import Jr from "../media/jr.JPG"
import {NavLink} from "react-router-dom"


const Navigation = ()=>{
    return(
        <div className="sidebar">
            <div className="id">
                <div className="idContent">
                    <img src={Jr} alt="Jr_logo"/>
                    <h3>Junior Kamanda</h3>
                </div>
            </div>

            <div className="navigation">
                <ul>
                    <li>
                        <NavLink exact to="/" activeClassName="active"> 
                            <i className="fa fa-home"></i>
                            <span>Acceuil</span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink exact to="/competences" activeClassName="active"> 
                            <i className="fa fa-book"></i>
                            <span>Compétences</span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink exact to="/portfolio" activeClassName="active"> 
                            <i className="fa fa-picture-o"></i>
                            <span>Portfolio</span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink exact to="/contact" activeclassName="active"> 
                            <i className="fa fa-address-book"></i>
                            <span>Contact</span>
                        </NavLink>
                    </li>
                </ul>
            </div>

            <div className="socialNetwork">
                <ul>
                    <li>
                        <a href="https://www.linkedin.com/in/junior-kamanda-20a68622a/" target="_blank" rel="noopener noreferrer">
                            <i className="fa fa-linkedin"></i>
                        </a>
                    </li>
                    <li>
                        <a href="https://github.com/JunKamanda" target="_blank" rel="noopener noreferrer">
                            <i className="fa fa-github"></i>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.google.com" target="_blank" rel="noopener noreferrer">
                            <i className="fa fa-twitter"></i>
                        </a>
                    </li>
                    <li>
                        <a href="https://web.facebook.com/junior.kaniynda.7/" target="_blank" rel="noopener noreferrer">
                            <i className="fa fa-facebook"></i>
                        </a>
                    </li>
                </ul>

                <div className="signature">
                    <p>JuniorKam's - 2022</p>
                </div>
            </div>

        </div>
    )
}

export default Navigation;